/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsApiKey
 */
export interface MelcoModelsApiKey {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    api_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsApiKey
     */
    expire_on?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    product_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsApiKey
     */
    product_id?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    scope?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsApiKey
     */
    melco_user_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsApiKey
     */
    created_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKey
     */
    user_id?: string | null;
}

export function MelcoModelsApiKeyFromJSON(json: any): MelcoModelsApiKey {
    return MelcoModelsApiKeyFromJSONTyped(json, false);
}

export function MelcoModelsApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsApiKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'api_key': !exists(json, 'api_key') ? undefined : json['api_key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'expire_on': !exists(json, 'expire_on') ? undefined : (json['expire_on'] === null ? null : new Date(json['expire_on'])),
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'melco_user_id': !exists(json, 'melco_user_id') ? undefined : json['melco_user_id'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
    };
}

export function MelcoModelsApiKeyToJSON(value?: MelcoModelsApiKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'api_key': value.api_key,
        'name': value.name,
        'expire_on': value.expire_on === undefined ? undefined : (value.expire_on === null ? null : value.expire_on.toISOString()),
        'product_code': value.product_code,
        'product_id': value.product_id,
        'product_name': value.product_name,
        'scope': value.scope,
        'melco_user_id': value.melco_user_id,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'user_id': value.user_id,
    };
}


